<template>
<app-header/>

<main class="app-main">
  <router-view/>
</main>

<app-footer/>
</template>

<script>
import { setLocale, defaultLocale } from '@/lib/i18n'
import AppHeader from './AppHeader'
import AppFooter from './AppFooter'

export default {
  components: { AppHeader, AppFooter },

  beforeRouteEnter (to, from) {
    setLocale(to.params.locale || defaultLocale())

    if (to.query.flightnumber) { localStorage.setItem('FLIGHT_NUMBER', to.query.flightnumber) }
    if (to.query.seatnumber) { localStorage.setItem('SEAT_NUMBER', to.query.seatnumber) }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  flex: 1 1 auto;
}
</style>
